import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription } from '@common-fe/common-fe';

import { FileImage } from '@/common/constants';

import DocumentImagePreview from './DocumentImagePreview';
import { DocumentCardWithFilesWrapper } from './DocumentUploadCard.styles';

interface Props {
  files: FileImage[];
  onOpenPreview?: () => void;
  onOpenUpload?: () => void;
}

const DocumentCardWithFiles: React.FC<Props> = ({ files, onOpenPreview, onOpenUpload }) => {
  const { t } = useTranslation();
  const fileCount = files.length;

  return (
    <DocumentCardWithFilesWrapper
      data-testid="document-upload-card"
      width="100%"
      style={{
        position: 'relative',
        maxWidth: '343px',
        height: '120px',
        minHeight: '120px',
        maxHeight: '120px',
      }}
      round="container1Round"
      background="module"
      flex={false}
      align="stretch"
    >
      <DocumentImagePreview files={files} onPreviewClick={onOpenPreview} />

      <Box
        style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '64px', zIndex: 2 }}
        pad="spacing12"
        round="container1Round"
        border={{ color: 'border2', size: '1px' }}
        background="canvas"
        direction="row"
        align="center"
        justify="between"
      >
        <Box direction="column" gap="spacing2">
          <Inscription
            data-testid="document-upload-card_title"
            weight="bold"
            color="textBody"
            lineHeight="20px"
          >
            {t('Documents')}
          </Inscription>
          <Inscription data-testid="document-upload-card_count" color="textSecondary" lineHeight="20px">
            {fileCount} {fileCount === 1 ? t('file') : t('files')}
          </Inscription>
        </Box>

        <AppButton
          testId="document-upload-card_upload-btn"
          buttonType="secondary"
          onClick={onOpenPreview || onOpenUpload}
          style={{ height: '32px', padding: '0 16px' }}
        >
          {t('View')}
        </AppButton>
      </Box>
    </DocumentCardWithFilesWrapper>
  );
};

export default DocumentCardWithFiles;
